import { render, staticRenderFns } from "./OfferRuler.vue?vue&type=template&id=24b620dc&"
import script from "./OfferRuler.vue?vue&type=script&lang=ts&"
export * from "./OfferRuler.vue?vue&type=script&lang=ts&"
import style0 from "./OfferRuler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports